import React, { useRef, useState } from 'react'
import dayjs from 'dayjs'
import { CSVLink } from 'react-csv'

import { Button } from '@st-operations/uikit/src/v2'
import toast from '@st-operations/uikit/lib/toast'

import camelCaseToSnakeCase from '_lib/camelCaseToSnakeCase'

import { get } from '_services/requests'
import { getOrgs } from '_services/permissions'

import './styles.scss'

const formatReports = (reports) => {
  const entries = Object.entries(reports ?? {}).map(([key, val]) => [
    `report_${camelCaseToSnakeCase(key)}`,
    val.selected,
  ])
  return Object.fromEntries(entries)
}

const AccountingModal = ({}) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const fromRef = useRef(null)
  const toRef = useRef(null)

  const generate = async () => {
    if (!(fromRef.current.value && toRef.current.value)) {
      toast.error('Define Delivery Range')
      return
    }
    setLoading(true)
    setData(null)

    const dates = [fromRef.current.value, toRef.current.value].sort()
    const start = dayjs(dates[0])
    const end = dayjs(dates[1])

    const audiences = (await get('media-measurement-campaigns')).items
    const { orgs } = await getOrgs()

    const inRange = audiences.filter((audience) => {
      if (audience?.deliveries?.[0]) {
        const deliveryDate = dayjs(audience.deliveries[0].deliveryDate)
        if (deliveryDate.isAfter(start) && deliveryDate.isBefore(end)) {
          return true
        }
      }
      return false
    })

    if (inRange.length === 0) {
      toast('No delivered audiences in this range')
      setLoading(false)
      return
    }

    const getDate = (date) => dayjs(date).format('YYYY-MM-DD')

    const getInferredOrg = (baseOrg, name) => {
      if (baseOrg === 'sharethis') {
        const org = orgs.filter((o) => name.toLowerCase().includes(o))
        return org[0] ?? '-'
      }
      return '-'
    }

    const data = inRange.map((item) => ({
      name: item.name,
      last_delivery: getDate(item.deliveries[0].deliveryDate),
      created_at: getDate(item.createdAt),
      created_by: item.createdBy.email,
      organization: item.createdBy.org,
      inferred_organization: getInferredOrg(item.createdBy.org, item.name),
      destination: item.deliveryDestination,
      last_delivery_size_insight: item.deliveries[0].deliverySize.insight,
      last_delivery_size_target: item.deliveries[0].deliverySize.target,
      last_delivery_path_insight: item.deliveries[0].deliveryPath.insight,
      last_delivery_path_target: item.deliveries[0].deliveryPath.target,
      audience_link: `https://datasphere.sharethis.com/online-media-measurements/${item._id}`,
      ...formatReports(item.reports),
    }))

    setLoading(false)
    setData(data)
  }

  return (
    <div className="omm-accounting-report">
      <h2>Accounting Report</h2>
      <div className="omm-accounting-report__inputs">
        <span>Delivery Range:</span>
        <input ref={fromRef} type="date" min="2023-08-01" />
        <span>to</span>
        <input ref={toRef} type="date" min="2023-08-01" />
      </div>
      <div className="omm-accounting-report__button">
        <Choose>
          <When condition={data}>
            <CSVLink
              data={data}
              filename={`Accounting Report - ${new Date().toISOString().split('T')[0]}.csv`}
              className="ds st-button default primary"
            >
              Download
            </CSVLink>
          </When>
          <Otherwise>
            <Button onClick={generate}>{loading ? 'Generating...' : 'Generate'}</Button>
          </Otherwise>
        </Choose>
      </div>
    </div>
  )
}

export default AccountingModal
